module.exports = __webpack_public_path__ + "media/images/header-rectangle-dad62b9b93e9b50c98d852adac18de57.svg";